<template>
  <div class="animated revealUp">

    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('emailtemplate') }}</div>
      <div>
        <router-link
          class="btn-blue"
          to="email-template"
        >{{ $t('emailtemplate') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="input-material">
            <input
              v-model="email_temp_name"
              v-validate="'required'"
              placeholder="."
              type="text"
              name="emailtemplatename"
              id="emailtemplatename"
            />
            <label>{{ $t('emailtemplate') }} {{ $t('name') }}</label>
          </div>
          <p v-if="submitted && errors.has('emailtemplatename')" class="error_message">
            <span>{{ errors.first("emailtemplatename")}}</span>
          </p>
        </div>

        <div class="col-lg-12 align-self-center mb-4">
          <div class="input-material">
            <input
              v-model="email_title"
              v-validate="'required'"
              placeholder="."
              type="text"
              name="emailtitle"
              id="emailtitle"
            />
            <label>{{ $t('email') }} {{ $t('title') }}</label>
          </div>
          <p v-if="submitted && errors.has('emailtitle')" class="error_message">
            <span>{{ errors.first("emailtitle")}}</span>
          </p>
        </div>
        <div class="editBtn col-lg-12 mb-4">
          <div class="float-right">
            <button class="btn btn-sm btn-primary" @click="isEdit = !isEdit; isEditHtml = false"><img v-if="!isEdit" src="@/assets/img/icons/edit-pen-white.svg" height="15" width="15" class="mr-1" />{{isEdit ? 'Save Page' : 'Edit Text'}}</button>
            <button class="btn btn-sm btn-primary" @click="isEditHtml = !isEditHtml; isEdit= false"><img v-if="!isEditHtml" src="@/assets/img/icons/edit-pen-white.svg" height="15" width="15" class="mr-1" />{{isEditHtml ? 'Save HTML' : 'Edit HTML'}}</button>
          </div>
        </div>
        <div class="col-lg-12 align-self-center mb-4">

          <div class="col-lg-12 align-self-center mb-4" v-if="isEdit">
              <vue-editor v-model="content" name="emaildesc" id="emaildesc" v-validate="'required'"></vue-editor>
            </div>
              <div class="input-material-textarea mb-4" v-else-if="isEditHtml && !isEdit">
                <textarea
                  id="htmlContent"
                  name="htmlContent"
                  v-model="content"
                  placeholder="Page Content"
                  class="htmlContent"
                />
            </div>
            <div class="col-lg-12 align-self-center mb-4 ql-snow" v-else>
              <div class="ql-editor content-box" v-html="content" v-if="content"></div>
              <div class="ql-editor text-center" v-else>No Content</div>
            </div>
            <vue-editor style="display:none"/>
          <p v-if="submitted && errors.has('emaildesc')" class="error_message">
            <span>{{ errors.first("emaildesc")}}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox v-model="email_temp_is_active" switch name="check-button"></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >{{ $t('update') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="email-template"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      btenable: false,
      submitted: false,
      content: "",
      et_id: "",
      email_temp_name: "",
      email_title: "",
      email_temp_is_active: true,
      keys: [],
      isEdit: false,
      isEditHtml: false
    };
  },
  beforeMount() {
    const { et_id } = this.$route.query;
    this.et_id = et_id;
    this.GetEmailTemplateByID(et_id);
  },
  methods: {
    onResetForm: function () {
      this.content = "";
      this.submitted = false;
      this.email_temp_name = "";
      this.email_title = "";
      this.email_temp_is_active = true;
    },
    GetEmailTemplateByID: function (id) {
      let payload = { et_id: id };

      MasterService.GetSingleEmailTemplate(payload)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.et_body) {
              let Obj = data.Records;
              this.email_temp_name = Obj.et_description;
              this.email_title = Obj.et_subject;
              this.email_temp_is_active = Obj.is_et_active === "Y" ? true : false;
              this.content = Obj.et_body;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    OnFinalSubmit: function () {
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;

          let payload = {
            et_id: this.et_id,
            et_subject: this.email_title,
            et_description: this.email_temp_name,
            content: this.content,
            is_et_active: this.email_temp_is_active ? 'Y' : 'N',
          };

          MasterService.EditEmailTemplate(payload)
            .then((response) => {
              this.btenable = false;

              const { data } = response;

              if (data && data.status) {
                this.submitted = false;

                this.$router.push({
                  path: "/master/email-template",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>
<style>
/* .editBtn {
  position: absolute;
  right: 0;
} */

.htmlContent {
  min-height: 250px !important
}

.content-box {
  min-height: 250px !important;
  border: 1px solid #d3d3d3;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/EmailTemplateComponents/editemailtemplate.vue